import React, { useEffect, useState } from 'react';
import { HitApi } from '../../Api/ApiHit';
import { searchTask } from '../../constant/Constant';
import { getSelectedUnit } from '../../storage/Storage';
import AddTask from './AddTask';
import { setApiJson } from '../../redux/Actions/ApiAction';
import { useDispatch } from 'react-redux';

function EditTask() {
    const [loading, setLoading] = useState(false);
    const url = window.location.pathname;
    const urlId = url.split('/')[3];
    const dispatch = useDispatch();

    console.log("urlId", urlId);

    useEffect(() => {
        getTask();
    }, []);

    // Function to convert timestamp to dropdown value format
    const convertTimestampToDropdownValue = (start, end) => {
        const startDate = new Date(start);
        const endDate = new Date(end);
        
        const formatTime = (date) => {
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            return `${hours}:${minutes}`;
        };
        
        const startTime = formatTime(startDate);
        const endTime = formatTime(endDate);
        
        return `${startTime}-${endTime}`;
    };

    const getTask = () => {
        setLoading(true);
        const json = {
            page: 1,
            limit: 10,
            search: {
                _id: urlId,
            }
        };

        HitApi(json, searchTask).then((res) => {
            
            // Updated condition based on actual API response structure
            if (res?.statusCode === 200) {
                const taskData = res?.data?.docs?.[0];
                
                // AssignedTo user IDs
                let assignedUserIds = [];
                if (taskData?.assignedTo && Array.isArray(taskData.assignedTo)) {
                    assignedUserIds = taskData.assignedTo.map(user => user._id || user);
                }

                // TaskIntervals processing - convert timestamps to dropdown values
                let taskIntervals = [];
                if (taskData?.taskIntervals && Array.isArray(taskData.taskIntervals)) {
                    taskIntervals = taskData.taskIntervals.map(interval =>
                        convertTimestampToDropdownValue(interval.start, interval.end)
                    );
                }

                // Convert string arrays to number arrays for dropdown compatibility
                const convertStringArrayToNumbers = (arr) => {
                    if (!Array.isArray(arr)) return [];
                    return arr.map(item => parseInt(item)).filter(item => !isNaN(item));
                };

                // Add additional fields based on the API response
                const data = {
                    taskName: taskData.taskName || '',
                    description: taskData.description || '',
                    priority: taskData.priority || '',
                    taskFrequency: taskData.taskFrequency || '',
                    roleId: taskData?.roleId?._id || '',
                    assignedTo: assignedUserIds,
                    taskIntervals: taskIntervals, // Array of dropdown values ["21:30-22:00"]
                    weekDays: convertStringArrayToNumbers(taskData.weekDays),
                    weekDaysForMonthly: convertStringArrayToNumbers(taskData.weekDaysForMonthly),
                    monthWeeks: convertStringArrayToNumbers(taskData.monthWeeks),
                    isCommon: taskData.isCommon || false,
                    unitIds: taskData.unitIds || '',
                    status: taskData.status || 'active'
                };
                
                dispatch(setApiJson(data));
            } else {
                console.error("No task data found or invalid response structure");
            }
            setLoading(false);
        }).catch((error) => {
            console.error("Error fetching task:", error);
            setLoading(false);
        });
    };

    if (loading) {
        return (
            <div className="flex justify-center items-center h-64">
                <div className="text-lg">Loading task data...</div>
            </div>
        );
    }

    return (
        <div>
            <AddTask editMode={true} />
        </div>
    );
}

export default EditTask;